import React, { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import "../Css/Header.css";
import logo from "../Assets/SportsForEquity-Logo.png";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isProgramsMobileOpen, setIsProgramsMobileOpen] = useState(false);
  const [isProgramsOpen, setIsProgramsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  function closeMobileMenu() {
    setIsMenuOpen(false);
    setIsProgramsMobileOpen(false);
  }

  function closeAll() {
    closeMobileMenu();
    setIsProgramsOpen(false);
  }

  /* Reset page scroll whenever a nav link is clicked, so the user always
     lands at the top of the target page (React Router preserves scroll
     position by default). */
  const scrollToTop = () =>
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });

  /* Close any open menus and jump to the top — used on every nav link. */
  function navClick() {
    closeAll();
    scrollToTop();
  }

  const location = useLocation();

  useEffect(() => {
    setIsMenuOpen(false);
    setIsProgramsMobileOpen(false);
    setIsProgramsOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth > 900) closeMobileMenu();
    }
    function handleScroll() {
      setScrolled(window.scrollY > 10);
    }
    function handleClickOutside(e) {
      if (!e.target.closest('.dropdown')) {
        setIsProgramsOpen(false);
      }
    }
    window.addEventListener("resize", handleResize);
    window.addEventListener("scroll", handleScroll);
    document.addEventListener("click", handleClickOutside);
    return () => {
      window.removeEventListener("resize", handleResize);
      window.removeEventListener("scroll", handleScroll);
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  return (
    <header className={`header${scrolled ? " header--scrolled" : ""}`}>
      <Link to="/" className="branding" onClick={navClick}>
        <img src={logo} alt="SportsForEquity Logo" className="logo-image" />
        <span className="logo-text">
          Sports<span className="logo-accent">For</span>Equity
        </span>
      </Link>

      {/* Hamburger */}
      <button
        type="button"
        className="mobile-menu-button"
        aria-label="Open menu"
        aria-expanded={isMenuOpen}
        onClick={() => (isMenuOpen ? closeMobileMenu() : setIsMenuOpen(true))}
      >
        <span className="mobile-menu-icon">
          <span className="mobile-menu-bar"></span>
          <span className="mobile-menu-bar"></span>
          <span className="mobile-menu-bar"></span>
        </span>
      </button>

      {/* Desktop nav */}
      <nav className="nav-links">
        <Link to="/" onClick={navClick}>Home</Link>

        <Link to="/research" className="nav-highlight-btn" onClick={navClick}>Why Table Tennis?</Link>

        {/* Programs dropdown */}
        <div className="dropdown">
          <button
            type="button"
            className="dropdown-title"
            onClick={(e) => { e.currentTarget.blur(); setIsProgramsOpen(!isProgramsOpen); }}
          >
            Programs
          </button>
          <div className={`dropdown-menu${isProgramsOpen ? " dropdown-menu--open" : ""}`}>
            <Link to="/programs/ParkinsonSession" onClick={navClick}>PingPongParkinson</Link>
            <Link to="/programs/CommunityOutreach" onClick={navClick}>Community Outreach</Link>
            <Link to="/programs/YouthEmpowerment" onClick={navClick}>Youth Empowerment</Link>
            <Link to="/programs/HealthEquitySupport" onClick={navClick}>Health Equity Support</Link>
          </div>
        </div>

        <Link to="/innovation-pongai" onClick={navClick}>Innovation &amp; PongAICoach</Link>

        <Link to="/Events" onClick={navClick}>Events Gallery</Link>
        <Link to="/impact-stories" onClick={navClick}>Impact Stories</Link>
        <Link to="/research-advocacy" onClick={navClick}>Research & Advocacy</Link>
        <Link to="/Blogs" onClick={navClick}>Media</Link>

        <Link to="/about" onClick={navClick}>About</Link>

        <Link to="/get-involved/join-us" onClick={navClick}>Contact</Link>
      </nav>

      {/* Mobile overlay */}
      <div
        className={`mobile-menu-overlay${isMenuOpen ? " open" : ""}`}
        onClick={closeMobileMenu}
      ></div>

      {/* Mobile panel */}
      <nav
        className={`mobile-menu-panel${isMenuOpen ? " open" : ""}`}
        aria-label="Mobile navigation"
      >
        <Link to="/" onClick={navClick}>Home</Link>

        <Link to="/research" className="nav-highlight-btn" onClick={navClick}>Why Table Tennis?</Link>

        {/* Mobile Programs toggle */}
        <button
          type="button"
          className={`mobile-team-toggle${isProgramsMobileOpen ? " open" : ""}`}
          aria-expanded={isProgramsMobileOpen}
          onClick={() => setIsProgramsMobileOpen(!isProgramsMobileOpen)}
        >
          Programs
          <span className="mobile-team-caret"></span>
        </button>

        <div className={`mobile-team-links${isProgramsMobileOpen ? " open" : ""}`}>
          <Link to="/programs/PingPongParkinson" onClick={navClick}>PingPongParkinson</Link>
          <Link to="/programs/CommunityOutreach" onClick={navClick}>Community Outreach</Link>
          <Link to="/programs/YouthEmpowerment" onClick={navClick}>Youth Empowerment</Link>
          <Link to="/programs/HealthEquitySupport" onClick={navClick}>Health Equity Support</Link>
        </div>

        <Link to="/innovation-pongai" onClick={navClick}>Innovation &amp; PongAICoach</Link>

        <Link to="/Events" onClick={navClick}>Events Gallery</Link>
        <Link to="/impact-stories" onClick={navClick}>Impact Stories</Link>
        <Link to="/research-advocacy" onClick={navClick}>Research & Advocacy</Link>
        <Link to="/Blogs" onClick={navClick}>Media</Link>

        <Link to="/about" onClick={navClick}>About</Link>

        <Link to="/get-involved/join-us" onClick={navClick}>Contact</Link>
      </nav>
    </header>
  );
};

export default Header;